import {
  Button,
  Icon,
  TableCell,
  TableRow,
  Typography,
  Grid
} from "@material-ui/core";
import React from "react";

const DescriptiveCell = props => {
  let hasBorder = props.count < 1;
  if (props.noBorder) hasBorder = false;
  if (props.hasBorder) hasBorder = true;

  return (
    
      <TableCell
        style={{
          borderBottom: hasBorder ? "1px solid #e0e0e0" : "0px",
          padding: "0px",
          paddingTop: "15px",
          width: "150em"
        }}
      >
        
          <Grid container>
            {props.description ? (
              <Grid item xs={6} sm={6} md={4}>
                <Typography>
                  <strong>{props.description}</strong>
                </Typography>
              </Grid>
            ) : null}

            <Grid item xs={2} sm={2} md={props.description ? 1 : 10}>
              <Button
                variant="fab"
                mini
                className="minifab"
                color="primary"
                style={{bottom:"3px"}}
                onClick={(event) => { event.stopPropagation(); props.add()}}
              >
                <Icon style={{ color: "white" }}>add</Icon>
              </Button>
            </Grid>
            <Grid item xs={2} sm={2} md={2} style={{ textAlign: "center" }}>
              <Typography variant="caption">
                <strong>{props.count === 0 ? "" : props.count}</strong>
              </Typography>
            </Grid>
          </Grid>
        
       
      </TableCell>
      
   
  );
};

export default DescriptiveCell;



// WEBPACK FOOTER //
// ./src/views/Bna/components/DescriptiveCell.jsx